






















import Vue from 'vue';
import ImagePreview from "./ImagePreview.vue";
import bytes from "bytes";
import isImage from "./helpers/isImage";
import LoadingBar from "./LoadingBar.vue";
import removeFileFromGFUploadedMeta from "./helpers/deleteFileFromHiddenGFInput";

export default Vue.extend({
	name: "File",
	props: [
		'file',
		'formId',
		'fieldId',
		'up',
		'enableCrop',
		'cropRequired',
		'onlyImagesAllowed',
	],
	data: function() {
		return {
			/**
			* Flag for whether or not a file has already been uploaded and this is a subsequent visit/reload.
			*
			* This is required so we can bypass the CSS animation.
			*/
			existingFile: false,
		}
	},
	beforeMount() {
		/**
		* If this component is mounted and the file percent is immediately 100%, we know that it's an existing file.
		*/
		if (this.file.percent === 100) {
			this.existingFile = true;
		}
	},
	components: {
		LoadingBar,
		ImagePreview,
	},
	methods: {
		getSize: function (file: MOxieFile) : string {
			return bytes(file.size);
		},
		isImage: function (file: MOxieFile) : boolean {
			return isImage(file);
		},
		deleteFile: function (file: MOxieFile, event: Event) : void {
		try {
			removeFileFromGFUploadedMeta(this.formId, this.fieldId, file);
			this.up.removeFile(file.id);
		} catch (e) {
			console.error('Error deleting file.', e);
		}
		},
	}
});
